export default __webpack_public_path__ + "static/media/2D.bc21ec2a.svg";